import React from "react";
import {Row, Col} from 'reactstrap'
import AccountPage from "./AccountPage";
import AccountNotificationsForm from "../../../components/forms/app/account/AccountNotificationsForm";

let AccountNotificationsPage = () => {

    return <AccountPage>
        <Row className='fitheight'>
            <Col lg={{size: 6, offset: 3}}>
                <AccountNotificationsForm/>
            </Col>
        </Row>
    </AccountPage>

}

export default AccountNotificationsPage
